import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, throwError, timeout } from 'rxjs';
import { catchError, concatMap, finalize } from 'rxjs/operators';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { INewsletterSaveDto } from '@pro-connect/shared';
import { NewsletterService } from './newsletter.service';

export class NewsletterStateSubmit {
  public static readonly type = '[NewsletterState] submit';

  public constructor(
    public readonly payload: {
      dto: INewsletterSaveDto;
    },
  ) {}
}

export interface NewsletterStateModel {
  loading: boolean;
}

@State<NewsletterStateModel>({
  name: 'newsletter',
  defaults: {
    loading: false,
  },
})
@Injectable()
export class NewsletterState {
  public constructor(
    private readonly _newsletterService: NewsletterService,
    private readonly _recaptchaV3Service: ReCaptchaV3Service,
  ) {}

  @Selector()
  public static loading({ loading }: NewsletterStateModel): boolean {
    return loading;
  }

  @Action(NewsletterStateSubmit)
  public submit(
    { patchState }: StateContext<NewsletterStateModel>,
    { payload: { dto } }: NewsletterStateSubmit,
  ): Observable<void> {
    patchState({ loading: true });
    return this._recaptchaV3Service.execute('importantAction').pipe(
      timeout({ first: 5000, with: () => throwError(() => 'timeout') }),
      concatMap((recaptchaKey: string) => this._newsletterService.submitMessage(dto, recaptchaKey)),
      catchError((error) => throwError(() => error)),
      finalize(() => {
        patchState({
          loading: false,
        });
      }),
    );
  }
}
